module.exports = __webpack_public_path__ + "Poppins-ExtraBold.90563fd83de2f8a8b444.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ExtraBold.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ExtraBold.woff2
// module chunks = styles